import { currentUserStore } from '../../../../../CurrentUserStore';
import { useFetchResource, useFindLinkByR } from '../../../../../Fetch';
import { declareEndpoint } from '../../../../../Links';

// DVLP-7601: fetch the ordered PLT list that powers the license selector
// dropdown in the admin preview. Backend orders by display_order desc — the
// caller picks the first entry as the initial "highest tier" selection.
// Passing the collection id populates each option's unlocks_count/total_count
// so the popover can show per-option upsell impact.

export const useLicenseOptions = (learningCollectionId: string) => {
  const link = useFindLinkByR(
    { rel: 'preview-license-options', method: 'get' },
    currentUserStore.links,
  );

  return useFetchResource(
    link
      .map((l) => {
        const sep = l.href.includes('?') ? '&' : '?';
        return { ...l, href: `${l.href}${sep}learning_collection_id=${learningCollectionId}` };
      })
      .map(declareEndpoint('/preview_license_options')),
  );
};
